import { Link } from 'react-router-dom';

interface CtaBandProps {
  title?: string;
  desc?: string;
}

export default function CtaBand({
  title = '把你知道的线索告诉我们',
  desc = '每一次核实过的曝光，都可能让一个正在犹豫的人停下来。你可以匿名提交，我们会认真对待每一条线索。',
}: CtaBandProps) {
  return (
    <section className="bg-secondary-950">
      <div className="mx-auto flex w-full max-w-content flex-col gap-8 px-4 py-14 md:flex-row md:items-center md:justify-between md:px-6 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-secondary-300">
            <span className="h-px w-6 bg-secondary-400" aria-hidden="true"></span>
            线索征集
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">{title}</h2>
          <p className="mt-4 text-sm leading-relaxed text-secondary-100/90 md:text-base">{desc}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/about"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            提交线索
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-600 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:bg-secondary-900"
          >
            查看常见问题
          </Link>
        </div>
      </div>
    </section>
  );
}